<template>
    <div class="dialogBg" :style="{
        backgroundImage: `url(${tips[type].bgc})`
    }">
        <div class="dialogContentBox">
            <div class="title">{{ tips[type].title }}</div>
            <div class="contentText">
                {{ tips[type].content }}
            </div>
            <div class="btns">
                <el-button type="primary" @click="toBack">返回列表</el-button>
                <el-button v-if="type == 'publish'"  @click="toQueue">查看队列</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
props:['type'],
data(){
    return{
tips: {
    'draft': {
        title: '保存成功',
        bgc: 'https://image2.soole.com.cn/slb-picture2025051319253682238.jpg',
        content: '数据保存成功，下次进入可直接进行更改'
    },
    'publish': {
        title: '排队成功',
        bgc: 'https://image2.soole.com.cn/slb-picture2025051318194877320.jpg',
        content: '请耐心等待视频生成，成功后即可在列表中查看'
    }
}
    }
},
methods:{
toBack() {
    window.history.back();
},
 toQueue (){
  this.$router.push({path:'productqueue'})
}
}
}



</script>
<style scoped lang="scss">
.dialogBg {
    background-repeat: no-repeat;
    background-size: cover;
    width: 583px;
    height: 443px;
}


.dialogContentBox {
    display: flex;
    flex-direction: column;
    position: relative;
    top: 188px;

    .title {
        font-weight: 600;
        font-size: 20px;
        margin-bottom: 30px;
        text-align: center;
    }

    .contentText {
        font-size: 16px;
        margin-bottom: 16px;
        color: rgba(31, 33, 38, 1);
        text-align: center;

        .num {
            color: rgba(246, 89, 54, 1);
        }
    }

    .subContent {
        margin: auto;
        width: 450px;
        font-size: 16px;
        color: rgba(172, 178, 195, 1);
        text-align: center;
        margin-bottom: 48px;
    }

    .btns {
        display: flex;
        gap: 26px;
        justify-content: center;
    }
}
</style>